import { z } from "zod";
import {
  EMAIL_INVALID,
  EMAIL_REQUIRED,
  PASSWORD_REQUIRED,
} from "@/constants/forms";

export const LoginSchema = z
  .object({
    email: z
      .string({
        invalid_type_error: EMAIL_INVALID,
        required_error: EMAIL_REQUIRED,
      })
      .email({ message: EMAIL_INVALID }),
    password: z
      .string()
      .nonempty(PASSWORD_REQUIRED),
  })
  .required()
  .strict();

export type LoginType = z.infer<typeof LoginSchema>;
